@import '../../utils/global.module.less';

.uploadButton {
    position: absolute;
    top: 6px;
    right: 8px;
    border-radius: 5px 10px 5px 5px !important;
}

.panelTableStyle {
    *[class*='grid_col_1'] {
        text-align: center;
        padding-left: 20px !important;
        text-align: left;
    }

    *[class*='grid_row'] {
        padding: 15px 0px !important;
        padding-left: 10px !important;
    }

    * > [class*='rowLabel'] {
        & > [class*='title'] {
            font-size: 14px !important;
            padding-left: 10px !important;
        }
        & > [class*='desc'] {
            font-size: 14px !important;
            padding-left: 10px !important;
        }
    }

    *[class*='grid_item'] {
        margin: 0px;

        padding-left: 5px !important;
        padding-right: 5px !important;
    }

    *[class*='source_page_entry'] {
        font-size: 12px !important;
    }

    *[class*='rowValue'] {
        font-weight: 400 !important;
        text-align: center;
    }

    //grid-template-columns: 1fr 100px 100px 100px 100px !important;
    //--panel-table-auto-row-width: minmax(auto, 600px);
    //--panel-table-label-column-width: 500px
    grid-template-columns: minmax(200px, 1fr) 4fr 80px !important;
}
